// Mock data for Flirty n Local clone

export const ASSETS = {
  // Original assets from flirtynlocal.com
  heartMainBanner: 'https://flirtynlocal.com/assets/icons/heart-main-banner.svg',
  smallHeart: 'https://flirtynlocal.com/assets/icons/small-heart.svg',
  yahooIcon: 'https://flirtynlocal.com/assets/icons/yahoo-icon.svg',
  membersImg: 'https://flirtynlocal.com/assets/image/home-page/how-it-works-banner/members.png',
  membersRadial: 'https://flirtynlocal.com/assets/image/home-page/how-it-works-banner/members-radial.png',
  rectangles: 'https://flirtynlocal.com/assets/image/home-page/how-it-works-banner/rectangles.png',
  find1: 'https://flirtynlocal.com/assets/image/home-page/how-it-works-banner/find-1-img.png',
  find2: 'https://flirtynlocal.com/assets/image/home-page/how-it-works-banner/find-2-img.png',
  membersIcon: 'https://flirtynlocal.com/assets/image/home-page/our-story-banner/members-icon.svg',
  messagesIcon: 'https://flirtynlocal.com/assets/icons/messages-icon.svg',
  woman1: 'https://flirtynlocal.com/assets/image/home-page/our-story-banner/woman-1.png',
  woman2: 'https://flirtynlocal.com/assets/image/home-page/our-story-banner/woman-2.png',
  woman3: 'https://flirtynlocal.com/assets/image/home-page/our-story-banner/woman-3.png',
  shield: 'https://flirtynlocal.com/assets/icons/shield-1.png',
  incognito: 'https://flirtynlocal.com/assets/icons/incognito-1.png',
  smallTalk: 'https://flirtynlocal.com/assets/icons/small-talk-1.png',
  halfHeart: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/half-heart-img.png',
  joinWoman: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/woman-img.png',
  joinWomanMobile: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/mobile-woman-img.png',
  mediumHeart: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/medium-heart-icon.png',
  smallIconHeart: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/small-icon-heart.png',
  rightGradient: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/right-gradient.svg',
  rightPurpleGradient: 'https://flirtynlocal.com/assets/image/home-page/join-now-banner/right-purple-gradient.svg',
  bgLeftSite: 'https://flirtynlocal.com/assets/image/home-page/bg-left-site.svg',
  bgRightSite: 'https://flirtynlocal.com/assets/image/home-page/bg-right-site.svg',
  // Hero background
  heroBg: 'https://images.unsplash.com/photo-1633369918397-ea852fe4e091?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxiZWRyb29tJTIwbW9ybmluZ3xlbnwwfHx8fDE3NzgwMDg1ODJ8MA&ixlib=rb-4.1.0&q=85',
};

export const STATS = [
  { value: '700K+', label: 'members', icon: ASSETS.membersIcon },
  { value: '1.5B+', label: 'messages sent', icon: ASSETS.messagesIcon },
];

export const SAFE_FUN_ITEMS = [
  {
    icon: ASSETS.shield,
    title: 'Safeguarded Community',
    text: "Flirty focuses as a priority to provide a secure environment for all of our users. We strongly encourage you to notify us of any user(s) that is not behaving accordingly.",
  },
  {
    icon: ASSETS.incognito,
    title: 'Member Discretion',
    text: "At Flirty we believe in sustaining the highest standards of user privacy. Our members security comes first and foremost. We highly value and respect the importance of one another's privacy. You can be assured that any information shared within our community will be kept to the highest levels of discretion.",
  },
  {
    icon: ASSETS.smallTalk,
    title: 'Exciting, Tempting and Playful',
    text: "With us at Flirty, we like to keep things exciting. Our members are able to enjoy a uniquely erotic experience while knowing their privacy is secured. This allows our members a rare opportunity for extreme enjoyment.",
  },
];

export const FOOTER_LINKS = [
  { label: 'Cookies', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Terms & Conditions', href: '#' },
  { label: 'Complaints Policy', href: '#' },
  { label: 'Trafficking Policy', href: '#' },
  { label: '2257', href: '#' },
  { label: 'Affiliates', href: '#' },
  { label: 'FAQ', href: '#' },
  { label: 'Contact', href: '#' },
];
